// This creates menu items for the custom forms menus pass it a list of menuItems, for example from main root or drawing office submenu etc.
export const createMenuItems = (menuItems) => {
  let items = [];
  _.each(menuItems, (menu) => {
    if (menu.menu_type == "module") {
      items.push({
        icon: `fa ${menu.icon}`,
        label: menu.label,
        to: `/custom_forms/menus/${menu.id}/module`,
      });
    } else if (menu.menu_type == "accordion") {
      const activeForms = _.filter(menu.custom_forms, (custom_form) => !custom_form.archived);
      const menuItems = _.map(activeForms, (custom_form) => {
        return {
          label: custom_form.name,
          to: `/custom_form/${custom_form.id}/records/`,
        };
      });

      items.push({
        icon: `fa ${menu.icon}`,
        label: menu.label,
        content: menuItems,
      });
    }
  });
  return items;
};


// This Creates menu items for custom_forms hardcoding to its records page
export const createCustomFormLinks = (custom_forms) => {
  let items = [];
  _.each(custom_forms, (custom_form) => {
    if (custom_form.archived) return;
    items.push({
      icon: `fa ${custom_form.icon}` || "fa fa-dot-circle-o",
      label: custom_form.name,
      to: `/custom_form/${custom_form.id}/records/`,
    });
  });
  return items;
};

